// Utility to get the appropriate authentication token
export const getAuthToken = () => {
  try {
    // First try to get tenant-scoped token
    const tenantToken = localStorage.getItem('tenantAccessToken');
    if (tenantToken) {
      return tenantToken;
    }
    
    // Fallback to regular access token
    const accessToken = localStorage.getItem('accessToken');
    return accessToken;
  } catch (error) {
    return null;
  }
};

// Utility to get auth headers
export const getAuthHeaders = (additionalHeaders = {}, skipContentType = false) => {
  try {
    const token = getAuthToken();

    if (!token) {
      const basicHeaders = {
        ...(skipContentType ? {} : { 'Content-Type': 'application/json' }),
        ...additionalHeaders
      };
      return basicHeaders;
    }

    const headers = {
      ...(skipContentType ? {} : { 'Content-Type': 'application/json' }),
      'Authorization': `Bearer ${token}`,
      ...additionalHeaders
    };

    return headers;
  } catch (error) {
    // Return basic headers if everything fails
    const fallbackHeaders = {
      ...(skipContentType ? {} : { 'Content-Type': 'application/json' }),
      ...additionalHeaders
    };
    return fallbackHeaders;
  }
};

// Global error handler for 401 responses
export const handleAuthError = (error = null) => {
  try {
    // If no error passed or if it's a 401, handle it
    if (!error || error.response?.status === 401) {
      // Clear all auth data
      try {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('tenantAccessToken');
        localStorage.removeItem('selectedWorkspace');
      } catch (clearError) {
        // Error clearing localStorage
      }
      
      // Redirect to login page
      try {
        window.location.href = '/login';
      } catch (redirectError) {
        // Error redirecting to login
      }
      
      return true; // Error was handled
    }
    return false; // Error was not handled
  } catch (handleError) {
    return false;
  }
};

// Setup global axios interceptor for 401 handling
export const setupGlobalErrorHandler = () => {
  // Check if axios is available (for fetch-based requests, we'll handle manually)
  if (typeof window !== 'undefined' && window.axios) {
    window.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (handleAuthError(error)) {
          return Promise.reject(new Error('Session expired - redirected to login'));
        }
        return Promise.reject(error);
      }
    );
  }
};
